import { IconBaseProps } from "react-icons";
import { RiMenuFill } from "react-icons/ri";

const Menu = (props: IconBaseProps): React.ReactElement => {
  return <RiMenuFill {...props} />;
};

export default Menu;
